import React from 'react';
import { Link } from 'react-router-dom';
import { Brain, ArrowLeft } from 'lucide-react';

const Section = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-lg font-semibold text-white mb-3">{title}</h2>
    <div className="text-gray-400 text-sm leading-relaxed space-y-2">{children}</div>
  </div>
);

const PrivacyPolicy = () => (
  <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
    <div className="max-w-2xl mx-auto px-6 py-12">

      <div className="flex items-center gap-3 mb-10">
        <div className="w-9 h-9 bg-gradient-to-br from-blue-500 to-purple-600 rounded-xl flex items-center justify-center">
          <Brain size={18} className="text-white" />
        </div>
        <span className="text-lg font-semibold">MLense Platform</span>
      </div>

      <h1 className="text-3xl font-bold mb-2">Privacy Policy</h1>
      <p className="text-gray-500 text-sm mb-10">Last updated: June 2026</p>

      <Section title="What We Collect">
        <p><span className="text-gray-300 font-medium">Account info</span> — your name and email address when you register.</p>
        <p><span className="text-gray-300 font-medium">Uploaded datasets</span> — files you upload to build and train ML models.</p>
        <p><span className="text-gray-300 font-medium">Usage data</span> — pipeline runs, model results, and error logs used to improve the service.</p>
      </Section>

      <Section title="How We Use It">
        <p>We use your data exclusively to operate the platform: running your pipelines, storing your models, and sending account-related emails (password reset, OTP).</p>
        <p>We do not sell your data. We do not use it for advertising.</p>
      </Section>

      <Section title="Where It Lives">
        <p>Data is stored on <span className="text-gray-300">MongoDB Atlas</span> (cloud database) and processed on <span className="text-gray-300">Google Cloud Run</span> servers, both in the United States.</p>
      </Section>

      <Section title="Third-Party Services">
        <p><span className="text-gray-300">Google Gemini</span> — used for AutoML suggestions and the AI chatbot. Queries you make may be processed by Google's API.</p>
        <p><span className="text-gray-300">Kaggle</span> — used only when you explicitly fetch a public dataset by name.</p>
      </Section>

      <Section title="Your Rights">
        <p>You can delete your account at any time. On deletion, your uploaded datasets and trained models are permanently removed within 30 days.</p>
        <p>You can request a copy of your data by emailing us.</p>
      </Section>

      <Section title="Cookies">
        <p>We use a single session token (JWT) stored in your browser's local storage to keep you logged in. No tracking cookies.</p>
      </Section>

      <Link
        to="/register"
        className="inline-flex items-center gap-2 text-sm text-blue-400 hover:text-blue-300 transition-colors mt-4"
      >
        <ArrowLeft size={15} />
        Back to registration
      </Link>

      <p className="text-gray-600 text-xs mt-10">© 2026 MLense Platform. All rights reserved.</p>
    </div>
  </div>
);

export default PrivacyPolicy;
